module.exports = __webpack_public_path__ + "img/bag(1).5cefade8.svg";